import React from "react";
import logo from '../img/Marca-Pattrol.png';
import { TopGreenBar } from './TopGreenBar';

export const Navigation = (props) => {

  return (

    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <TopGreenBar />
      <div className='container' style={{padding:3}}>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          
          <a href='#page-top'>
            <img src={logo} height={40} alt="Pattrol" />
          </a>
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a href='#manifesto' className='page-scroll'>
                Quem Somos
              </a>
            </li>
            <li>
              <a href='#qualidade-top' className='page-scroll'>
                Qualidade
              </a>
            </li>
            <li>
              <a href='#missao-top' className='page-scroll'>
                Missão
              </a>
            </li>
            <li>
              <a href='#valores-top' className='page-scroll'>
                Valores
              </a>
            </li>
            <li>
              <a href='#servicos-top' className='page-scroll'>
                Serviços
              </a>
            </li>
            <li>
              <a href='#contato-top' className='page-scroll'>
                Contato
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

  )
}
